import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function QuoteCTA() {
  return (
    <section
      className="relative py-32 lg:py-44 px-6 lg:px-10 border-t border-[color:var(--border)] overflow-hidden"
      data-testid="quote-cta-section"
    >
      <div className="ambient-glow-blue" style={{ bottom: "-30%", left: "-10%", opacity: 0.5 }} />
      <div className="ambient-glow-navy" style={{ top: "-20%", right: "-10%", opacity: 0.5 }} />

      <div className="mx-auto max-w-[1400px] relative">
        <Reveal>
          <div className="text-[11px] uppercase tracking-[0.4em] text-[color:var(--blue)]">
            The next step
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display font-semibold text-[clamp(3rem,10vw,10rem)] leading-[0.88] text-white">
            Free water<br />
            <span className="font-editorial italic font-normal text-[color:var(--blue)]">
              test, on us.
            </span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-12 gap-6 lg:gap-10 items-end">
          <div className="col-span-12 lg:col-span-6 lg:col-start-2">
            <Reveal delay={0.2}>
              <p className="text-[16px] lg:text-[18px] leading-[1.7] text-[color:var(--muted)] font-body max-w-lg">
                A Vanguard Water Systems specialist comes to your home. We test your water. We show you what's in it. We recommend the right Kinetico system for your home and your budget — with zero pressure to buy.
              </p>
            </Reveal>
          </div>
          <div className="col-span-12 lg:col-span-4 flex flex-col gap-3">
            <Reveal delay={0.3}>
              <Link to="/contact" className="btn-primary" data-testid="quote-cta-primary">
                Request a Free Test <ArrowUpRight className="h-4 w-4" />
              </Link>
            </Reveal>
            <Reveal delay={0.4}>
              <a href="tel:+14357017171" className="btn-ghost" data-testid="quote-cta-call">
                <Phone className="h-4 w-4" /> (435) 701-7171
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
